import { SUBCLUSTERS } from '../subclusters.js';

const PRODUCT_MANAGEMENT_CLUSTER = {
    subclusters: [
        { key: SUBCLUSTERS.TASK_MANAGEMENT },
        { key: SUBCLUSTERS.SPRINT_MANAGEMENT },
        { key: SUBCLUSTERS.KANBAN },
        { key: SUBCLUSTERS.STORIES_EPICS_MANAGEMENT },
        { key: SUBCLUSTERS.ROADMAP_PLANNING },
        { key: SUBCLUSTERS.RELEASE_MANAGEMENT },
        { key: SUBCLUSTERS.TEAM_MANAGEMENT },
        { key: SUBCLUSTERS.TRACKING_PRODUCT_METRICS },
        { key: SUBCLUSTERS.CROSS_TEAM_COLLABORATION },
        { key: SUBCLUSTERS.REPORTS_DASHBOARDS },
        { key: SUBCLUSTERS.PRIORITIZE_PERSONAL_WORK },
        { key: SUBCLUSTERS.MARKET_RESEARCH },
        { key: SUBCLUSTERS.CUSTOMER_COMMUNICATION },
        { key: SUBCLUSTERS.FEATURE_PRIORITIZATION },
        { key: SUBCLUSTERS.BACKLOG_MANAGEMENT },
    ],
};

export { PRODUCT_MANAGEMENT_CLUSTER };
